module.exports = {"es-PY":{"notifications":{"index":{"title":"Notificaciones","empty":"Sin resultados","unread":"Solo notificaciones no leídas"}}}}